// extracted by mini-css-extract-plugin
export default {"innerWrapper":"sB-z","tooltipWrapper":"tB-z","icon":"uB-z","tooltip":"vB-z","content":"wB-z"};